<template>
  <ContentWrapper>
    <div class="content-heading">
      <div>회원 통계</div>
      <!-- Breadcrumb right aligned-->
      <ol class="breadcrumb ml-auto">
        <li class="breadcrumb-item">
          <a href="#">Home</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#">통계관리</a>
        </li>
        <li class="breadcrumb-item active">회원통계</li>
      </ol>
    </div>
    <!-- 검색  -->
    <div class="card-body" style="background-color:#fff;">
      <b-card no-body>
        <b-tabs card >
          <!-- 회원 유형 가입 통계-->
          <b-tab title="회원 유형별 가입통계" active>
              <b-card-text>
                  <div class="card-body">
                    <div class="form-row align-items-center">
                        <!-- 기간검색 -->
                        <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
                        <!-- 조회주기 -->
                        <StateCycle label="조회주기" :data="data" @search="search" @reset="reset"  />
                        <!-- 항목 검색 -->
                        <div class="col-auto">
                            <b-button-group>
                                <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
                                <button @click="reset()" class="btn btn-secondary  mb-2">Clear</button>
                            </b-button-group>
                        </div>
                    </div>
                  </div>
              </b-card-text>
          </b-tab>
          <!-- 회원 유형 가입 통계-->
          <b-tab title="지역별 가입통계">
              <b-card-text class="col-auto">
                  <div class="card-body">
                      <div class="form-row">
                          <!-- 상품 채널 -->
                          <div class="form-group col-auto">
                              <label class="col-form-label ml-1">초등</label>
                              <input type="checkbox" class="ml-2" v-model="data.row.teacher" true-value="Y" false-value="N">
                              <label class="form-check-label ml-2">교사채널</label>
                              <input type="checkbox" class="ml-2" v-model="data.row.tutor" true-value="Y" false-value="N">
                              <label class="form-check-label ml-2">강사채널</label>
                          </div>
                          <!-- 기간검색 -->
                          <SchDateRange label="기간" :data="data" @search="search" @reset="reset" />
                          <!-- 항목 검색 -->
                          <div class="col-auto">
                              <b-button-group>
                                  <button @click="search()" class="btn btn-primary mb-2"><i class="fa fa-search"></i>Search</button>
                                  <button @click="reset()" class="btn btn-secondary mb-2">Clear</button>
                              </b-button-group>
                          </div>
                      </div>
                  </div>
              </b-card-text>
          </b-tab>
        </b-tabs>
      </b-card>
    </div>
    <!-- // 검색 -->
    <div class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">총량</span>
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
            <tr>
              <td style="text-align:center" >학교선생님<em class="fa-2s mr-2 fas"></em></td>
              <td style="text-align:center" >학원선생님<em class="fa-2s mr-2 fas"></em></td>
              <td style="text-align:center" >학생<em class="fa-2s mr-2 fas"></em></td>
              <td style="text-align:center" >학부모<em class="fa-2s mr-2 fas"></em></td>
              <td style="text-align:center" >합계<em class="fa-2s mr-2 fas"></em></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="align-middle text-center">{{data.total.teacherCnt}}</td>
              <td class="align-middle text-center">{{data.total.tutorCnt}}</td>
              <td class="align-middle text-center">{{data.total.studentCnt}}</td>
              <td class="align-middle text-center">{{data.total.parentsCnt}}</td>
              <td class="align-middle text-center">{{data.total.totalCnt}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <!-- 목록 -->
    <div v-show="data.params.mode=='list'" class="card card-default">
      <div class="card-header mt-2">
        <span class="text-bold h4">가입통계</span>
        <div class="card-tool float-right" >
<!--          <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="saveDetail()" >등록</b-btn>-->
            <b-btn class="btn btn-xs btn-outline-info mr-2" variant="outline-primary" style="width:100px;" @click="excelDownload()" >엑셀 다운로드</b-btn>
        </div>
        <ShowCounter label="Show" :data="data" @search="search" />
      </div>
      <div class="card-body">
        <table class="table table-striped table-bordered table-hover">
          <thead>
          <tr>
            <td style="text-align:center" >No<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >일자<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >학교선생님<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >학원선생님<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >학생<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >학부모<em class="fa-2s mr-2 fas"></em></td>
            <td style="text-align:center" >합계<em class="fa-2s mr-2 fas"></em></td>
          </tr>
          </thead>

          <tbody>
          <tr v-show="data.count==0" class="text-center"><td colspan="9">No matching records</td> </tr>
          <tr v-show="data.count!=0" v-for="(item, index) in data.list" :key="index"  > <!--  @click.prevent="edit(item.seq);" -->
            <td class="align-middle text-center">{{item.seq}}</td>
            <td class="align-middle text-center">{{item.periodDt}}</td>
            <td class="align-middle text-center">{{item.teacherCnt}}</td>
            <td class="align-middle text-center">{{item.tutorCnt}}</td>
            <td class="align-middle text-center">{{item.studentCnt}}</td>
            <td class="align-middle text-center">{{item.parentsCnt}}</td>
            <td class="align-middle text-center">{{item.totalCnt}}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="card-footer">
        <div class="d-flex">
          <!--paging component-->
          <Pagenation :data="data" @next="dataAction.next(search)" @prev="dataAction.prev(search)" @first="dataAction.first(search)" @last="dataAction.last(search)" :key="data.params.page"/>
        </div>
      </div>
    </div>
    <!-- // 목록 -->

  </ContentWrapper>
</template>
<script>
import Vue from 'vue'
import { reactive, ref, computed, onMounted, onUnmounted ,onBeforeMount} from '@vue/composition-api'
import {dataObject} from "@/utils/Constants";
import {getMemberTypeStatsList,getMemberTypeStatsTotal,getMemberAreaStatsList,getMemberTypeStatsListExcelDownload} from "@/api/stats/MemberTypeStatsApi";
import Pagenation from "@/components/Common/Pagenation";
import {TableActionClass} from "@/utils/TableActionClass";
import SchDateRange from "../../components/Common/SchDateRange";
import StateCycle from "../../components/Common/StateCycle";
import SchText from "../../components/Common/SchText";
import ShowCounter from "../../components/Common/ShowCounter";
import Keyword from "../../components/Common/Keyword";
import BoardCatList from "../notice/component/BoardCatList";
import Datepicker from 'vuejs-datepicker'
import Axios from 'axios';
import moment from 'moment';

// 로딩처리
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

import draggable from 'vuedraggable'
// 목차/차시/파일

import VueQuillEditor from 'vue-quill-editor'

import 'quill/dist/quill.core.css' // import styles
import 'quill/dist/quill.snow.css' // for snow theme
import 'quill/dist/quill.bubble.css' // for bubble theme
import vueMoment from 'vue-moment' 

Vue.use(vueMoment)
Vue.use(VueQuillEditor, /* { default global options } */)

export default {
  components: {SchDateRange, StateCycle, SchText, ShowCounter, Pagenation,  Loading, draggable, Keyword, Datepicker,BoardCatList, },

  setup(){
    const _dataObject = _.cloneDeep(dataObject);
    _dataObject.total = {
      teacherCnt: 0,
      tutorCnt: 0,
      parentsCnt: 0,
      studentCnt: 0,
      totalCnt: 0,
    };
    const data = reactive(_dataObject)
    const Datedata = reactive({
      postDt: new Date(),
      postDtChk : false,
      endDt: new Date('9999-12-31'),
      endDtChk : false,
    })

    const loadData = async () => {
        // 데이터 초기화
        data.params.cycleType = "day";

        console.log('처음 접속시 데이터 가지고 오기');
      // data.params.bookTypeCd = '330001';
      // let result = await getNoticeList(data.params);
      // data.list = result.data;
      // data.count = result.data.length;
      // getBoardCatOption();
    }

    const changeDate = (type) =>{
       let _temp = type == 'now' ? data.row.postDt : data.row.endDt;

       if(type == 'now'){
         if(Datedata.postDtChk == true){
           data.row.postDt = new Date();
           Datedata.postDt = _.cloneDeep(_temp);
         }
         else{
           data.row.postDt = Datedata.postDt;
         }
       }else{
         if(Datedata.endDtChk == true){
          data.row.endDt = new Date(9998,11,31);
          Datedata.endDt =  _.cloneDeep(_temp);
         }
         else{
           data.row.endDt = Datedata.endDt;
         }
       }
    }

    const fileRemove = ()=>{
        data.row.url = null;
    }

    // NOTUSED
    // const excelDownload = () => {
    //     console.log("엑셀다운로 실행");
    //       // downloadAs();
    // }
//     const downloadAs = () => {
//       const url = data.row.url;
//       const name = data.row.name;
// //        let fullUrl = aws_cdn_path + url;
//         Axios.get(url, {
//         headers: {
//           "Content-Type": "application/octet-stream"
//         },
//         responseType: "blob"
//       })
//         .then(response => {
//           const a = document.createElement("a");
//           const url = window.URL.createObjectURL(response.data);
//           a.href = url;
//           a.download = name;
//           a.click();
//         })
//         .catch(err => {
//           console.log("error", err);
//         });
//     };

    onMounted(loadData)

    return{
      dataObject,
      _dataObject,
      data,
      Datedata,
      changeDate,
      fileRemove,
      // excelDownload, //NOTUSED
      // downloadAs,
      ...methods(),
      dataAction: new TableActionClass(data),
    }
  },
}

function methods() {
  var context = {};
  context["getMemberTypeStatsList"] = getMemberTypeStatsList;
  context["getMemberAreaStatsList"] = getMemberAreaStatsList;

  // 목록
  async function search() {
    let _params = this.data.params;
    await this.dataAction.execute("getMemberTypeStatsList",context,_params);
    const total = await getMemberTypeStatsTotal(_params);
    if (total.data.length>0) {
      this.data.total.teacherCnt = total.data[0].teacherCnt;
      this.data.total.tutorCnt = total.data[0].tutorCnt;
      this.data.total.parentsCnt = total.data[0].parentsCnt;
      this.data.total.studentCnt = total.data[0].studentCnt;
      this.data.total.totalCnt = total.data[0].totalCnt;
    }

    this.fileRemove();
  }
  // // 저장 NOTUSED
  // async function save() { 
  //   if (!confirm("내용을 저장 하시겠습니까?")) {
  //       // 취소(아니오) 버튼 클릭 시 이벤트
  //       return false;
  //   } else {
  //       // 확인(예) 버튼 클릭 시 이벤트
  //       var formData = new FormData();

  //       if(this.data.row.seq !=null){
  //           formData.append("seq", this.data.row.seq);
  //           formData.append("fixedYn", this.data.row.fixedYn == null ? 'Y' : this.data.row.fixedYn);
  //           formData.append("boardCatSeq", this.data.row.boardCatSeq);
  //           formData.append("title", this.data.row.title);
  //           formData.append("content", this.data.row.content);
  //           formData.append("exhibitionStatus", this.data.row.exhibitionStatus == null ? 'N' : this.data.row.exhibitionStatus);
  //           formData.append("keywords", this.keywords.text);
  //           formData.append("teacherUseYn", this.data.row.teacherUseYn == null ? 'N' : this.data.row.teacherUseYn,);
  //           formData.append("tutorUseYn", this.data.row.tutorUseYn == null ? 'N' : this.data.row.tutorUseYn);
  //           formData.append("studentUseYn", this.data.row.studentUseYn == null ? 'N' : this.data.row.studentUseYn);
  //           formData.append("parentsUseYn", this.data.row.parentsUseYn == null ? 'N' : this.data.row.parentsUseYn);
  //           formData.append("mfile", this.uploadImageFileValue);
  //           formData.append("endDt", moment(this.data.row.endDt, 'YYYY-MM-DD').format("yyyy-MM-DD HH:mm:ss"));
  //           formData.append("postDt", moment(this.data.row.postDt, 'YYYY-MM-DD').format("yyyy-MM-DD HH:mm:ss"));
  //           formData.append("noticeAttachSeq", this.data.row.noticeAttachSeq);
  //       }else{
  //           formData.append("fixedYn", this.data.row.fixedYn == null ? 'Y' : this.data.row.fixedYn);
  //           formData.append("boardCatSeq", this.data.row.boardCatSeq);
  //           formData.append("title", this.data.row.title);
  //           formData.append("content", this.data.row.content);
  //           formData.append("exhibitionStatus", this.data.row.exhibitionStatus == null ? 'N' : this.data.row.exhibitionStatus);
  //           formData.append("keywords", this.keywords.text);
  //           formData.append("teacherUseYn", this.data.row.teacherUseYn == null ? 'N' : this.data.row.teacherUseYn,);
  //           formData.append("tutorUseYn", this.data.row.tutorUseYn == null ? 'N' : this.data.row.tutorUseYn);
  //           formData.append("studentUseYn", this.data.row.studentUseYn == null ? 'N' : this.data.row.studentUseYn);
  //           formData.append("parentsUseYn", this.data.row.parentsUseYn == null ? 'N' : this.data.row.parentsUseYn);
  //           formData.append("mfile", this.uploadImageFileValue);
  //           formData.append("endDt", moment(this.data.row.endDt, 'YYYY-MM-DD').format("yyyy-MM-DD HH:mm:ss"));
  //           formData.append("postDt", moment(this.data.row.postDt, 'YYYY-MM-DD').format("yyyy-MM-DD HH:mm:ss"));
  //           formData.append("noticeAttachSeq", this.data.row.noticeAttachSeq);
  //       }
  //       let result = await setNoticeList(formData).then((result) => {
  //         if(result.data){
  //           alert('저장 완료되었습니다.');
  //         }
  //       });
  //    }
  // }
  // 초기화
  async function reset(){
    this.data.params.mode="list";
  }
  async function excelDownload() {
    let _params = this.data.params;
    const name = '회원유형별 가입통계';
    await getMemberTypeStatsListExcelDownload(_params, name);
  }

  return {
    search,
    reset,
    // save,
    excelDownload
  }
}

</script>
